var map = {
	"./audio-placeholder": 634,
	"./audio-placeholder.png": 634,
	"./avatar-missing": 327,
	"./avatar-missing.png": 327,
	"./avatar-missing.svg": 875,
	"./halloween/clouds": 635,
	"./halloween/clouds.png": 635,
	"./halloween/halloween-emblem": 654,
	"./halloween/halloween-emblem.svg": 654,
	"./halloween/spider": 655,
	"./halloween/spider.svg": 655,
	"./halloween/spiderweb": 656,
	"./halloween/spiderweb.svg": 656,
	"./halloween/starfield": 657,
	"./halloween/starfield.png": 657,
	"./halloween/twinkle": 658,
	"./halloween/twinkle.svg": 658,
	"./header-missing": 352,
	"./header-missing.png": 352,
	"./reticle": 659,
	"./reticle.png": 659,
	"./soapbox-logo": 353,
	"./soapbox-logo-white": 354,
	"./soapbox-logo-white.svg": 354,
	"./soapbox-logo.svg": 353,
	"./sprite-post-functions": 667,
	"./sprite-post-functions.png": 667,
	"./video-placeholder": 671,
	"./video-placeholder.png": 671,
	"./void": 672,
	"./void.png": 672,
	"./web-push/web-push-icon_expand": 704,
	"./web-push/web-push-icon_expand.png": 704,
	"./web-push/web-push-icon_favourite": 705,
	"./web-push/web-push-icon_favourite.png": 705,
	"./web-push/web-push-icon_reblog": 706,
	"./web-push/web-push-icon_reblog.png": 706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 874;